import styled from 'styled-components';

export const Container = styled('div')`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding-bottom: 0.5em;
    border-bottom: 1px solid #ccc;
  }

  p {
    margin: 0.5em 0;
    overflow-wrap: anywhere;
  }

  ul,
  ol {
    margin: 1em 0;
    padding-left: 2em;
  }

  a {
    color: #007bff;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }

  pre {
    background-color: #dfdfdf;
    padding: 1em;
    border-radius: 4px;
    overflow-x: auto;
    font-family: 'Courier New', Courier, monospace;
  }

  code {
    background-color: #dfdfdf;
    padding: 0.2em 0.4em;
    border-radius: 4px;
    font-family: 'Courier New', Courier, monospace;
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 0.5em 0;
  }

  summary {
    cursor: pointer;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 1em 0;

    th,
    td {
      padding: 0.5em;
      border: 1px solid #333;
      text-align: left;
    }

    th {
      background-color: #ddd;
    }
  }

  blockquote {
    margin: 0.5em 0;
    padding: 0.5em 1em;
    border-left: 3px solid #ddd;
    color: #555;
  }
`;
